import * as React from 'react';
import styled from 'styled-components';
import { generateId } from '@agilepoint/utils-common';
import { IBaseComponentProps } from '../../types';
import { CarouselContext } from './carousel-context';
import { FlexBox } from '../../flex-box';

export interface IItemProps extends IBaseComponentProps<HTMLDivElement> {
    id?: React.Key;
    children?: React.ReactChild;
}

interface IItemsWrapperProps {
    shouldUseDots?: boolean;
    isHorizontal?: boolean;
    indicatorPosition?: 'left' | 'right';
}

export const Item = React.memo((props: IItemProps) => {
    const { removeItem, addItem } = React.useContext(CarouselContext);
    const id = React.useMemo(() => (props.id || generateId()), [props.id]);
    React.useEffect(() => {
        addItem({ ...props, id });
    }, [addItem, id, props]);
    React.useEffect(() => () => { removeItem(id); }, [id, removeItem]);
    return null;
});

Item.displayName = 'CarouselItem';

export const ItemsWrapper = styled(FlexBox).attrs(() => ({
    className: String('ap-carousel-itemsWrapper')
})) <IItemsWrapperProps>`
    height: ${({ isHorizontal, shouldUseDots }) => getContainerHeight(isHorizontal, shouldUseDots)};
    width: ${({ isHorizontal, shouldUseDots }) => getContainerWidth(isHorizontal, shouldUseDots)};
    left: ${({ isHorizontal, shouldUseDots, indicatorPosition }) => (!isHorizontal && shouldUseDots && indicatorPosition === 'left' ? '25px' : 'unset')};
    position: relative;
    overflow: hidden;
`;

export const ItemWrapper = styled.div.attrs(() => ({
    className: 'ap-carousel-itemWrapper'
}))`
  display: inherit;
  width: 100%;
  height: 100%;
  position: relative;
`;

function getContainerHeight(isHorizontal?: boolean, shouldUseDots?: boolean) {
    if (isHorizontal && shouldUseDots) {
        return 'calc(100% - 25px)';
    }
    return '100%';
}

function getContainerWidth(isHorizontal?: boolean, shouldUseDots?: boolean) {
    if (!isHorizontal && shouldUseDots) {
        return 'calc(100% - 25px)';
    }
    return '100%';
}
